import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {DonneesChampModel} from '../parametre-donnees.types';
import {ParametreDonneesStateService} from '../parametre-donnees-state.service';

@Component({
  selector: 'app-parametre-donnees-affichage-tab',
  templateUrl: './parametre-donnees-affichage-tab.component.html',
  styleUrls: ['./parametre-donnees-affichage-tab.component.scss']
})
export class ParametreDonneesAffichageTabComponent implements OnChanges {
  @Input() moduleKey = 'produits';

  champs: DonneesChampModel[] = [];

  constructor(
    private readonly state: ParametreDonneesStateService,
    private readonly toastr: ToastrService
  ) {}

  ngOnChanges(ch: SimpleChanges): void {
    if (ch['moduleKey']) {
      this.load();
    }
  }

  load(): void {
    this.champs = this.state.getChamps(this.moduleKey);
  }

  save(): void {
    this.state.saveChampsBulkApi(this.moduleKey, this.champs).subscribe({
      next: () => {
        this.load();
        this.toastr.success('Affichage enregistré.', 'Succès');
      },
      error: () => {}
    });
  }

  trackById(_: number, c: DonneesChampModel): string {
    return c.id;
  }
}
